// @ts-ignore
import VueMatomo from 'vue-matomo'

export default defineNuxtPlugin(({ vueApp }): void => {
    const { enabled, siteId, host } = useRuntimeConfig().public.matomo

    if (!enabled) {
        return
    }

    vueApp.use(VueMatomo, {
        host,
        siteId,
        enableLinkTracking: false,
        // Measure cookielessly until the user grants analytics consent (CZ opt-in / ePrivacy).
        // Cookies are enabled later via setCookieConsentGiven() from the cookie bar.
        requireCookieConsent: true,
    })

    // Restore cookie consent from a previous visit so returning, consenting users keep cookies.
    if (isAnalyticsConsentGranted()) {
        setMatomoCookieConsent(true)
    }
})
